(function ($) {

	// Add .is-active to What's New block on homepage
	var selector = ".m-home-new__button";

	$(selector).on("click", function () {
		$(selector).removeClass("is-active");
		$(this).addClass("is-active");
	});

})(jQuery);